import { useEffect, useState } from 'react'
import { usePostHog } from 'posthog-js/react'

/*
  Whether PostHog has finished loading feature flags. When PostHog is not
  configured (e.g. local dev without an API key) flags are treated as ready so
  callers fall back to their default behaviour, mirroring Split's offline mode.
*/
export function useFeatureFlagsReady(): boolean {
  const posthog = usePostHog()
  const [, setFlagsVersion] = useState(0)

  useEffect(() => {
    if (!posthog) {
      return undefined
    }

    return posthog.onFeatureFlags(() => setFlagsVersion(version => version + 1))
  }, [posthog])

  const isConfigured = !!posthog && posthog.__loaded === true

  return !isConfigured || Boolean(posthog?.featureFlags?.hasLoadedFlags)
}
